var _defs, _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496.01 241.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 189.41,
    y1: 61,
    x2: 231.5,
    y2: 61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2792d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104ea2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 741.52,
    y1: -1261.66,
    x2: 741.52,
    y2: -1200.47,
    gradientTransform: "translate(613.23 1478.29) rotate(-45)",
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "255.12 0 217.71 31.87 217.71 71.38 203.56 83.38 203.56 121.99 255.12 78.02 255.12 0",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.22 142.39 276.64 110.52 276.64 61.02 290.79 49.01 290.79 20.4 239.22 64.37 239.22 142.39",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 200.78)",
    style: {
      fontSize: 82,
      fill: "#2a2a2a",
      fontFamily: "Graphik-Semibold, Graphik",
      fontWeight: 600
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "-0.07499285442073171em"
    }
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.8,
    y: 0,
    style: {
      letterSpacing: "-0.000005954649390243903em"
    }
  }, "echnoc"), /*#__PURE__*/React.createElement("tspan", {
    x: 337.1,
    y: 0,
    style: {
      letterSpacing: "-0.009991901676829269em"
    }
  }, "r"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 369.81,
    y: 0
  }, "om"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(14.86 235.18)",
    style: {
      fontSize: "28.921049118041992px",
      fill: "#010101",
      fontFamily: "Graphik-Light, Graphik",
      fontWeight: 300,
      letterSpacing: "0.3400117351764916em"
    }
  }, "S", /*#__PURE__*/React.createElement("tspan", {
    x: 27.24,
    y: 0,
    style: {
      letterSpacing: "0.3449922933907557em"
    }
  }, "ucc"), /*#__PURE__*/React.createElement("tspan", {
    x: 106.08,
    y: 0,
    style: {
      letterSpacing: "0.3499897348532038em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 132.23,
    y: 0,
    style: {
      letterSpacing: "0.3449922933907557em"
    }
  }, "ss "), /*#__PURE__*/React.createElement("tspan", {
    x: 196.2,
    y: 0,
    style: {
      letterSpacing: "0.3349974104658596em"
    }
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 232.5,
    y: 0,
    style: {
      letterSpacing: "0.34500917663893965em"
    }
  }, "ith Quality")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.68efd9727e71a838df5dd885097c9ede.svg";
export { ForwardRef as ReactComponent };